import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { CheckIcon, MenuIcon, ShoppingBagIcon, StarIcon } from 'lucide-react';
import { useCart } from '../../contexts/CartContext';
import { mainNav, usps } from '../../data/navigation';
import { SearchBox } from './SearchBox';
import { MobileMenu } from './MobileMenu';
export function Header() {
  const {
    count,
    open
  } = useCart();
  const [menuOpen, setMenuOpen] = useState(false);
  return <>
      <div className="bg-ink text-canvas" data-id="element-198" data-mp="lygoc9ovz4sp">
        <div className="mx-auto flex h-9 max-w-7xl items-center justify-center gap-8 px-5 text-xs lg:justify-between lg:px-8" data-id="element-199" data-mp="i098dh28y7ik">
          <ul className="flex items-center gap-7" data-id="element-200" data-mp="vs7dlgsu7j9g">
            {usps.map((u, i) => <li key={u} className={`items-center gap-1.5 whitespace-nowrap ${i === 0 ? 'flex' : 'hidden md:flex'}`} data-id="element-201" data-mp="qz4hp20l7xq3" data-mpi={i}>
                <CheckIcon className="h-3.5 w-3.5 text-[#E7B79F]" aria-hidden="true" data-id="element-202" data-mp="38ifvsh6f9oj" />
                {u}
              </li>)}
          </ul>
          <p className="hidden items-center gap-1.5 lg:flex" data-id="element-203" data-mp="6wgknb8dl6wq">
            <StarIcon className="h-3.5 w-3.5 fill-[#E7B79F] text-[#E7B79F]" aria-hidden="true" data-id="element-204" data-mp="6tuar4y0ifbc" />
            4,8 · 3.100+ reviews
          </p>
        </div>
      </div>

      <header className="sticky top-0 z-40 border-b border-line bg-canvas/95 backdrop-blur" data-id="element-205" data-mp="gm034fs6eyr2">
        <div className="mx-auto flex h-16 max-w-7xl items-center gap-4 px-5 lg:h-[4.5rem] lg:gap-10 lg:px-8" data-id="element-206" data-mp="lk1lszloww20">
          <button type="button" onClick={() => setMenuOpen(true)} className="-ml-2 grid h-10 w-10 place-items-center rounded-full lg:hidden" aria-label="Menu openen" data-id="element-207" data-mp="3k41hz8w299qq">
            <MenuIcon className="h-5 w-5" data-id="element-208" data-mp="1wlsz5gs0dam" />
          </button>
          <Link to="/" className="text-xl font-semibold tracking-[0.24em] text-ink" aria-label="AMIRA, naar home" data-id="element-209" data-mp="1y58uuyismbv">
            AMIRA
          </Link>
          <div className="hidden max-w-xl flex-1 lg:block" data-id="element-210" data-mp="1dbh80sjc4grp">
            <SearchBox data-id="element-211" data-mp="1d9xrr1xoi5px" />
          </div>
          <div className="ml-auto flex items-center gap-5" data-id="element-212" data-mp="3ac4z9ng1mymm">
            <Link to="/over-amira" className="hidden whitespace-nowrap text-sm text-muted transition-colors duration-150 hover:text-ink xl:block" data-id="element-213" data-mp="3aehnujgb478n">
              Over Amira
            </Link>
            <button type="button" onClick={open} className="flex h-11 items-center gap-2 rounded-full bg-ink pl-4 pr-1.5 text-sm font-medium text-canvas transition-colors duration-150 hover:bg-clay" aria-label={`Winkelwagen, ${count} artikelen`} data-id="element-214" data-mp="3jca3jopxxgwk">
              <ShoppingBagIcon className="h-4 w-4" aria-hidden="true" data-id="element-215" data-mp="2mkzh31mmru95" />
              <span className="hidden sm:inline" data-id="element-216" data-mp="30fs4em8rieqa">Winkelwagen</span>
              <span className="grid h-8 min-w-8 place-items-center rounded-full bg-canvas px-2 text-xs font-semibold text-ink tabular-nums" data-id="element-217" data-mp="2vn8qfo65xhky">
                {count}
              </span>
            </button>
          </div>
        </div>

        <div className="px-5 pb-3 lg:hidden" data-id="element-218" data-mp="22ya56i6qtzbf">
          <SearchBox data-id="element-219" data-mp="ih0ymyhwx3tk" />
        </div>

        <nav aria-label="Shop" className="hidden border-t border-line lg:block" data-id="element-220" data-mp="ifzcnyzcywx2">
          <div className="mx-auto flex h-12 max-w-7xl items-center justify-between px-8" data-id="element-221" data-mp="n7r2u8elr0mo">
            <ul className="flex items-center gap-8" data-id="element-222" data-mp="9gma7q9nj8lu">
              {mainNav.map(item => <li key={item.to} data-id="element-223" data-mp="eenx6ma77s2l">
                  <NavLink to={item.to} className={({
                isActive
              }) => `whitespace-nowrap text-sm font-medium transition-colors duration-150 ${isActive ? 'text-clay' : 'text-ink hover:text-clay'}`} data-id="element-224" data-mp="efp72nfha8iq">
                    {item.label}
                  </NavLink>
                </li>)}
            </ul>
            <Link to="/product/hammam-ritueel-set" className="whitespace-nowrap rounded-full bg-surface px-4 py-1.5 text-sm font-medium text-ink transition-colors duration-150 hover:bg-line" data-id="element-225" data-mp="x3u7bkwxfbcs">
              Hammam Ritueel Set — € 59,95
            </Link>
          </div>
        </nav>
      </header>

      <MobileMenu open={menuOpen} onClose={() => setMenuOpen(false)} data-id="element-226" data-mp="3sf2uqzvu78sq" />
    </>;
}